export enum ProNumberMaxLengthsEnum {
  INPUT = 11,
  DIGITS = 10,
  MIN = 9,
}
